<template>
    <div class="card" id="url_to_activate">
        <div class="card-body">
            <div class="divide-y">
                <div class="row">
                    <span class="col-4">
                        <label class="form-label">Ссылка для активации</label>
                    </span>
                    <span class="col-8">
                        <input type="text" class="form-control" v-model="fields.url_to_activate" placeholder="Ссылка для активации" @change="onChange" />
                        <div v-if="v$.url_to_activate.$invalid">
                            <span :class="{'is-invalid': v$.url_to_activate.$invalid && v$.url_to_activate.$dirty}"></span>
                            <div class="invalid-feedback" v-for="error of v$.url_to_activate.$silentErrors" :key="error.$uid">
                                {{ error.$message }}
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent, watch, onMounted, reactive} from "vue"
import {useVuelidate} from "@vuelidate/core/dist/index.esm"
import {minLength} from "@/plugins/vuelidator"

export default defineComponent({
    name: "UrlActivate",
    props: {
        data: {
            type: [Object, null],
            default: null,
        },
    },
    setup(props, {emit}) {
        const fields = reactive({
            url_to_activate: null,
        })

        onMounted(() => {
            fields.url_to_activate = props.data.val;
        })

        watch(() => props.data.val, (val) => {
            fields.url_to_activate = val
        })

        const rules = {
            url_to_activate: {
                minLength: minLength(0),
            },
        }

        let $externalResults = reactive({})    

        const v$ = useVuelidate(rules, fields, {$externalResults})

        function validate(fn) {
            v$.value.$clearExternalResults()

            return v$.value.$validate().then(async () => {
                await fn()
            })
        }

        watch(() => props.data["validations"], (val) => {
            validate(() => {
                if (val?.url_to_activate !== undefined) {
                    $externalResults.url_to_activate = val["url_to_activate"][0]
                }
            })
        })

        function onChange() {
            validate(() => {})
            emit("onChange", fields.url_to_activate)
        }

        return {
            onChange,
            v$,
            fields,
        }
    }
})
</script>

<style scoped>

</style>
